// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3rBOB","options":"AnswerScale_options__2Biff","selected":"AnswerScale_selected__16Ain"};